import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { BehaviorSubject } from 'rxjs';
import { take } from 'rxjs/operators';
import { AppState } from 'src/app/store';
import { selectDomain } from 'src/app/store/selectors/auth.selectors';

interface AiOverlayState {
  isOpen: boolean;
  firstMessage?: string;
}

@Injectable({
  providedIn: 'root',
})
export class AiOverlayService {
  private overlaySubject = new BehaviorSubject<AiOverlayState>({
    isOpen: false,
  });

  overlay$ = this.overlaySubject.asObservable();

  constructor(
    private store: Store<AppState>,
  ) {}

  open(firstMessage?: string) {
    this.store.select(selectDomain).pipe(take(1)).subscribe(() => {
      this.overlaySubject.next({
        isOpen: true,
        firstMessage,
      });
    });
  }

  close() {
    this.overlaySubject.next({
      isOpen: false,
    });
  }
}
